export interface ErrorResponse {
    message: string
    category: number
    code: number
}

export class ErrorResponseThrowable extends Error {
    errorResponse: ErrorResponse

    constructor(errorResponse: ErrorResponse) {
        super(errorResponse?.message)
        this.errorResponse = errorResponse
    }
}

// Backend messages arrive prefixed with the Coral `<category>:<code>:` pair, eg.
// `0004:000C:Substitute module versions must be unique: <id>`. That prefix means nothing to the
// user, so strip it before displaying.
const CORAL_ERROR_CODE_PREFIX = /^[0-9A-F]{4}:[0-9A-F]{4}:\s*/i

/**
 * Pulls the displayable message out of an error thrown by a service call. Prefers the backend's
 * message (attached by `handleAxiosError`) and falls back to the thrown error's own message.
 * Returns undefined when neither yields anything, so callers can supply a generic fallback.
 */
export const getApiErrorMessage = (e: unknown): string | undefined => {
    const message =
        (e as ErrorResponseThrowable | undefined)?.errorResponse?.message ??
        (e as Error | undefined)?.message
    return message?.replace(CORAL_ERROR_CODE_PREFIX, '').trim() || undefined
}
